module.exports = __webpack_public_path__ + "playground.38ccb8c62444c1abc47fa5ae5a36bf56.png";